import { ToolGroupEntry } from '../../extensions/tool-extension';
import { DefaultToolCallGroup } from './DefaultToolCallGroup';
import { InlineToolGroup } from './InlineToolGroup';

type ToolCallGroupProps = {
  entries: ToolGroupEntry[];
  variant?: 'default' | 'inline';
  indented?: boolean;
};

export const ToolCallGroup = ({
  entries,
  variant = 'default',
  indented = false,
}: ToolCallGroupProps) => {
  if (variant === 'inline') {
    return <InlineToolGroup entries={entries} indented={indented} />;
  }

  return <DefaultToolCallGroup entries={entries} />;
};
